<template>
  <v-container fluid class="add-currency">
    <div
      class="d-flex flex-column justify-between align-start align-md-center fill-height fill-width pa-2"
    >
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" class="pa-2">
          <v-text-field
            v-model="currencyModel.name"
            :rules="rules"
            required
            :label="$t('panel.currencyManagementPage.addCurrencyPage.name')"
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-text-field
            v-model="currencyModel.iso"
            :rules="rules"
            required
            :label="$t('panel.currencyManagementPage.addCurrencyPage.iso')"
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-text-field
            v-model="currencyModel.contractId"
            :rules="rules"
            required
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.contractId')
            "
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-switch
            v-model="currencyModel.isActive"
            :label="$t('panel.currencyManagementPage.addCurrencyPage.isActive')"
          ></v-switch>

          <v-switch
            v-model="currencyModel.isWalletManagerSupport"
            :label="
              $t(
                'panel.currencyManagementPage.addCurrencyPage.isWalletManagerSupport'
              )
            "
          ></v-switch>
        </v-col>

        <v-col cols="12" md="6" lg="4" class="pa-2">
          <v-file-input
            v-model="currencyModel.logo"
            :label="$t('panel.currencyManagementPage.addCurrencyPage.logo')"
            filled
            dense
            prepend-inner-icon="mdi-image"
            prepend-icon=""
            class="theme-custom-input mx-auto mx-md-0"
          ></v-file-input>

          <v-text-field
            v-model="currencyModel.commission"
            :rules="rules"
            required
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.commission')
            "
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-text-field
            v-model="currencyModel.maxAmount"
            :rules="rules"
            required
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.maxAmount')
            "
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-switch
            v-model="currencyModel.isBitrahSupport"
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.riverPaySupport')
            "
          ></v-switch>

          <v-switch
            v-model="currencyModel.supportDestinationTag"
            :label="
              $t(
                'panel.currencyManagementPage.addCurrencyPage.supportDestinationTag'
              )
            "
          ></v-switch>
        </v-col>

        <v-col cols="12" md="6" lg="4" class="pa-2">
          <v-text-field
            v-model="currencyModel.network"
            :rules="rules"
            required
            :label="$t('panel.currencyManagementPage.addCurrencyPage.network')"
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-text-field
            v-model="currencyModel.minAmount"
            :rules="rules"
            required
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.minAmount')
            "
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-text-field
            v-model="currencyModel.precision"
            :rules="rules"
            required
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.precision')
            "
            filled
            dense
            class="theme-custom-input mx-auto mx-md-0"
          >
          </v-text-field>

          <v-switch
            v-model="currencyModel.secondLayer"
            :ripple="false"
            :label="
              $t('panel.currencyManagementPage.addCurrencyPage.secondLayer')
            "
          />
        </v-col>
      </v-row>

      <v-btn
        color="primary"
        to="/panel/currency-management/add-currency"
        width="378px"
        class="py-6 my-4 mx-auto"
      >
        {{ $t("panel.currencyManagementPage.addCurrencyPage.submit") }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "add-currency",
  data() {
    return {
      currencyModel: {
        commission: 0,
        contractId: "",
        isActive: true,
        isBitrahSupport: true,
        isWalletManagerSupport: true,
        iso: "",
        logo: undefined,
        maxAmount: 0,
        minAmount: 0,
        name: "",
        network: "",
        precision: 0,
        secondLayer: true,
        supportDestinationTag: true
      },
      rules: [
        v =>
          !!v ||
          this.$t("panel.currencyManagementPage.addCurrencyPage.notEmpty")
      ]
    };
  }
};
</script>

<style lang="scss">
@import "AddCurrency";
</style>
